import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Fetch all schedules
export const fetchSchedules = createAsyncThunk(
  'schedules/fetchSchedules',
  async () => {
    const response = await api.get('/schedules/');
    return response.data;
  }
);

// Update schedules from PDF
export const updateSchedules = createAsyncThunk(
  'schedules/updateSchedules',
  async () => {
    const response = await api.post('/schedules/update_schedule/');
    return response.data;
  }
);

// Reset schedules
export const resetSchedules = createAsyncThunk(
  'schedules/resetSchedules',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post('/schedules/reset/');
      return response.data;
    } catch (error) {
      if (error.response?.status === 403) {
        return rejectWithValue('Only administrators can reset schedules');
      }
      return rejectWithValue(error.response?.data?.detail || 'Failed to reset schedules');
    }
  }
);

export const signUpForClass = createAsyncThunk(
  'schedules/signUpForClass',
  async (scheduleId) => {
    const response = await api.post(`/schedules/${scheduleId}/signup/`);
    return response.data;
  }
);

export const cancelClassSignUp = createAsyncThunk(
  'schedules/cancelClassSignUp',
  async (scheduleId) => {
    const response = await api.delete(`/schedules/${scheduleId}/signup/`);
    return response.data;
  }
);

const schedulesSlice = createSlice({
  name: 'schedules',
  initialState: {
    schedules: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchSchedules
      .addCase(fetchSchedules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchSchedules.rejected, (state, action) => {
        state.loading = false;
        // Only set error if not null (don't show error for auth issues)
        if (action.payload) {
          state.error = action.payload;
        }
        state.schedules = [];
      })
      // Handle updateSchedules
      .addCase(updateSchedules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.schedules = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(updateSchedules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle resetSchedules
      .addCase(resetSchedules.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetSchedules.fulfilled, (state) => {
        state.loading = false;
        state.schedules = [];
      })
      .addCase(resetSchedules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle signUpForClass
      .addCase(signUpForClass.fulfilled, (state, action) => {
        // Handle successful sign up
      })
      // Handle cancelClassSignUp
      .addCase(cancelClassSignUp.fulfilled, (state, action) => {
        // Handle successful cancellation
      });
  },
});

export const { clearError } = schedulesSlice.actions;
export default schedulesSlice.reducer; 